<template>
  <div>
    <a-card :bordered="false" :title="title">
      <!--      <div id="printMe" style="width: 292px;height: 100px;" v-show="true">-->
      <!--        <div style="font-size: 12px;color: #000000;padding-left: 5px">-->
      <!--          <div>Apple iPhone 11 Pro Max 全新机 国行CH 64G 黑色 华强北</div>-->
      <!--          <div>IMEI: 126085965769895</div>-->
      <!--        </div>-->
      <!--          <svg id="barcode"></svg>-->
      <!--      </div>-->
      <!--      <br/>-->
      <!--      <button v-on:click="print">Print local range</button>-->
    </a-card>
  </div>
</template>

<script>

  //import JsBarcode from 'jsbarcode'

  export default {
    name: 'Analysis',
    components: {},
    data() {
      return {
        loading: false,
        title: '欢迎来到分毫后台管理系统。',
      }
    },
    mounted() {
      // JsBarcode(
      //   "#barcode",
      //   "4136a1259b1011ea9afa0242ac110003",
      //   {
      //     height: 24,
      //     width: 0.8,
      //     fontSize: 14
      // });
      // JsBarcode("#barcode")
      //   .options({
      //     // font: "OCR-B",
      //     height:100
      //   })      // 会影响所有条形码
      //   .EAN13("1234567890128", {fontSize: 12, textMargin: 0})
      //   .blank(0)        // 在条形码之间创建空间
      //   .render();
    },
    methods: {
      // print() {
      //   let dom = document.querySelector("#printMe")
      //   this.$print(dom)
      // }
    }
  }
</script>

<style lang="scss" scoped>
  .registStyle span {
    margin-right: 3%;
  }

  .extra-wrapper {
    line-height: 55px;
    padding-right: 24px;

    .extra-item {
      display: inline-block;
      margin-right: 24px;

      a {
        margin-left: 24px;
      }
    }
  }

  /* 首页访问量统计 */
  .head-info {
    position: relative;
    text-align: left;
    padding: 0 32px 0 0;
    min-width: 125px;

    &.center {
      text-align: center;
      padding: 0 32px;
    }

    span {
      color: rgba(0, 0, 0, .45);
      display: inline-block;
      font-size: .95rem;
      line-height: 42px;
      margin-bottom: 4px;
    }

    p {
      line-height: 42px;
      margin: 0;

      a {
        font-weight: 600;
        font-size: 1rem;
      }
    }
  }
</style>